'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgClearCircle(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...props },
        React__default.default.createElement("defs", null,
            React__default.default.createElement("path", { d: "M8 2c3.312 0 6 2.688 6 6s-2.688 6-6 6-6-2.688-6-6 2.688-6 6-6zM5.836 5.836a.6.6 0 000 .848l1.272 1.273L5.836 9.23a.6.6 0 10.848.848l1.273-1.273 1.273 1.273a.6.6 0 10.848-.848L8.805 7.957l1.273-1.273a.6.6 0 10-.848-.848L7.957 7.108 6.684 5.836a.6.6 0 00-.848 0z", id: "Clear-circle_svg__a" })),
        React__default.default.createElement("use", { fill: "currentColor", xlinkHref: "#Clear-circle_svg__a", fillRule: "evenodd" })));
}

module.exports = SvgClearCircle;
//# sourceMappingURL=ClearCircle.js.map
